<script lang="ts">
	import clickOutside from '$lib/actions/clickOutside';
	import Button from '$lib/buttons/v3/button.svelte';
	import Close from '$lib/icons/close.svelte';
	import type { Snippet } from 'svelte';
	import { fade } from 'svelte/transition';

	interface Props {
		padding?: boolean;
		children?: Snippet;
	}

	let { padding = true, children }: Props = $props();

	let overlay = $state<HTMLDivElement | null>(null);
	let showOverlay = $state(false);
	let enableClickOutside = $state(false);

	export function show() {
		showOverlay = true;
	}

	export function close() {
		enableClickOutside = false;
		showOverlay = false;
	}

	$effect(() => {
		if (overlay) {
			document.body.appendChild(overlay);
		}
	});
</script>

{#if showOverlay}
	<div
		bind:this={overlay}
		class="fixed inset-0 z-[70] flex flex-col items-center justify-center bg-gray-2/50"
		transition:fade={{ duration: 200 }}
		onintroend={() => (enableClickOutside = true)}
	>
		<div
			class="relative flex w-full flex-col justify-between overflow-hidden bg-stone-5 max-lg:h-full lg:max-h-[72%] lg:min-h-[460px] lg:w-[696px] lg:rounded-[20px]"
			use:clickOutside={enableClickOutside ? close : undefined}
		>
			<div
				class:px-5={padding}
				class:pt-14={padding}
				class:pb-4={padding}
				class:lg:p-10={padding}
				class="scrollbar-hide overflow-y-auto bg-stone-5 max-lg:h-full lg:mt-0"
			>
				{@render children?.()}
			</div>
			<div class="absolute right-3 top-3 lg:right-4 lg:top-4">
				<Button class="btn-brown" onclick={close}>
					<Close class="h-6 w-6" />
				</Button>
			</div>
		</div>
	</div>
{/if}
